import App from "../../package.json";

export const APP_NAME = App.name;
export const IS_APP_PRODUCTION = process.env.REACT_APP_PRODUCTION === "true";
export const APP_VERSION = App.version;
export const API_URL = process.env.REACT_APP_API_URL;
